import { FormattedNumber } from "react-intl";

import { Text } from "@/components/atoms/Text";

import type { FsvPaymentScheduleStepProps } from "./FsvPaymentSchedule.types";

/**
 * Renders one numbered payment milestone with its amount and explanation.
 */
export const FsvPaymentScheduleStep = ({
  amount,
  currency,
  description,
  number,
  title,
}: FsvPaymentScheduleStepProps) => (
  <div className="tw-flex tw-items-start tw-gap-16">
    <Text
      aria-hidden={true}
      className="tw-flex tw-size-24 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-purple-600 tw-text-brand-white"
      element="span"
      typeface="body-1-m"
    >
      {number}
    </Text>
    <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-4">
      <div className="tw-flex tw-justify-between tw-gap-12 tw-text-purple-600">
        <Text element="div" typeface="body-2-m">
          {title}
        </Text>
        <Text className="tw-shrink-0" element="div" typeface="body-2-m">
          <FormattedNumber
            currency={currency}
            maximumFractionDigits={0}
            minimumFractionDigits={0}
            style="currency"
            value={Math.ceil(amount)}
          />
        </Text>
      </div>
      <Text className="tw-text-gray-900" element="div" typeface="body-1-long">
        {description}
      </Text>
    </div>
  </div>
);
